<fikoyt-fiko-three-js #fikoThreejs
                      [antiAlias]="false"
                      [enableShadows]="false"
                      [maxFPS]="60"
                      [pixelRatio]="2"
                      [enablePostProcessing]="false"
                      [enableFrustumCulling]="false"
                      [enableLOD]="false"
                      [gomulu]="gomulu"></fikoyt-fiko-three-js>

<!-- 🪶 Gömülü mod (kart önizleme vb.): toolbar/panel/dialog UI'sız, sadece canvas+orbit -->
@if (!gomulu) {

<!-- 🔢 Sayısal Giriş (CATIA Sketch Tools) — çizerken uzunluk/açı/yarıçap yaz, Enter ile uygula -->
@if(mdlSayisalAlanlar.length){
  <div class="mdl-sayisal-panel" [style.left.px]="mdlSayisalPos.x" [style.top.px]="mdlSayisalPos.y">
    @for(a of mdlSayisalAlanlar; track a.anahtar){
      <div class="mdl-sayisal-alan">
        <label>{{a.etiket}}</label>
        <input type="number" [placeholder]="a.deger" [(ngModel)]="mdlSayisalGiris[a.anahtar]" (keydown.enter)="mdlSayisalUygula()" (keydown.tab)="$event.preventDefault(); $any($event.target).nextElementSibling?.querySelector?.('input')?.focus()" />
        <span class="mdl-sayisal-birim">{{a.birim}}</span>
      </div>
    }
    <button class="mdl-sayisal-ok" (click)="mdlSayisalUygula()" title="Uygula (Enter)"><i class="icon check"></i></button>
  </div>
}

<!-- ✏️ Flyout menüleri — KÖK seviyede (toolbar stacking context'inin dışında → ağacın önünde) -->
@if(modellemeAcik && modellemeDurum === 'sketch' && mdlFlyoutAcik === 'profil'){
  <div class="mdl-fly-menu mdl-fly-kok" [style.left.px]="mdlFlyoutPos.x" [style.top.px]="mdlFlyoutPos.y">
    <div class="mdl-fly-bas">Profil</div>
    @for(k of mdlProfilKomutlari; track k.id){
      <button class="mdl-fly-item" [class.aktif]="modellemeAktifArac===k.id" (click)="mdlProfilSec(k)">
        <i class="icon {{k.ikon}}"></i><span>{{k.etiket}}</span><kbd>{{k.ks}}</kbd>
      </button>
    }
  </div>
}
@if(modellemeAcik && modellemeDurum === 'sketch' && mdlFlyoutAcik === 'operasyon'){
  <div class="mdl-fly-menu mdl-fly-kok" [style.left.px]="mdlFlyoutPos.x" [style.top.px]="mdlFlyoutPos.y">
    <div class="mdl-fly-bas">Operasyon</div>
    @for(k of mdlOperasyonKomutlari; track k.id){
      <button class="mdl-fly-item" (click)="mdlOperasyonSec(k)">
        <i class="icon {{k.ikon}}"></i><span>{{k.etiket}}</span>
      </button>
    }
  </div>
}
@if(modellemeAcik && modellemeDurum === 'sketch' && mdlFlyoutAcik === 'kisit'){
  <div class="mdl-fly-menu mdl-fly-kok" [style.left.px]="mdlFlyoutPos.x" [style.top.px]="mdlFlyoutPos.y">
    <div class="mdl-fly-bas">Kısıtlar</div>
    @for(k of mdlKisitKomutlari; track k.id){
      <button class="mdl-fly-item" (click)="mdlKisitSec(k)">
        <i class="icon {{k.ikon}}"></i><span>{{k.etiket}}</span>
      </button>
    }
  </div>
}

<!-- ✏️ Ölçü etiketleri (dimensions) — kök seviye, kamera takipli, çift-tıkla düzenle -->
@for(o of modellemeOlcuListesi; track o.id){
  <div class="mdl-olcu" [style.left.px]="o.x" [style.top.px]="o.y">
    @if(olcuDuzenle?.id === o.id){
      <input #olcuInp class="mdl-olcu-input" type="number" [value]="olcuDuzenle.deger"
             (keyup.enter)="olcuDuzenle.deger=+olcuInp.value; olcuKaydet()"
             (keyup.escape)="olcuIptalEt()" (blur)="olcuDuzenle.deger=+olcuInp.value; olcuKaydet()" autofocus>
    } @else {
      <span (dblclick)="olcuCiftTik(o)" (contextmenu)="olcuSagMenu($event, o)" title="Çift-tıkla değiştir · sağ-tık menü">{{o.metin}}</span>
    }
  </div>
}

@if(gosterSolAracCubugu){
<div class="solAracCubugu">
    <button id="butonCncProgramciSolMenu"
            class="circular ui icon blue mini button"
            (click)="solAracCubuguAcik=!solAracCubuguAcik;CD.detectChanges();">
        <i class="icon bars"></i>
    </button>

    <button id="butonCncProgramciSolMenu"
            class="circular ui icon blue mini button"
            (click)="listeModuAktif=!listeModuAktif;CD.detectChanges();">
        <i class="icon lock"
           [class.open]="listeModuAktif"></i>
    </button>

    <button class="circular ui icon blue mini button"
            (click)="fikoThreejs.acAyarlarDialogu();CD.detectChanges();">
        <i class="icon cog"></i>
    </button>

    <button class="circular ui icon mini button"
            [class.aktif-mdl]="modellemeAcik"
            (click)="modellemeToggle()"
            title="Parametrik Modelleme (CATIA tarzı sketch + Pad)"
            style="padding: 0; background: linear-gradient(135deg, #0ea5e9 0%, #22d3ee 100%);">
        <i class="icon cube"
           style="height: 22px;width: 22px;line-height: 22px; color: white;"></i>
    </button>

    <button id="butonFikoOlcum"
            class="circular ui icon green mini button"
            [class.fiko-kilit]="!lisans('OLCUM')"
            style="padding: 0;"
            (click)="acFikoOlcumDialog()">
        <!-- <i class="icon ruler"></i> -->
        <img src="/simgeler/kumpas.webp"
             style="width: 22px !important; height: 22px; object-fit: contain;">
    </button>

    <button id="butonFikoTersAci"
            class="circular ui icon purple mini button"
            [class.fiko-kilit]="!lisans('ANALIZ','ters_aci')"
            style="padding: 0;"
            (click)="acFikoTersAciAnaliziDialog()"
            title="FikoYT Ters Açı Analizi">
        <img src="/simgeler/xyz-1.webp"
             style="width: 22px !important; height: 22px; object-fit: contain;">
    </button>
    <button id="butonFikoRadiusAnalizi"
            class="circular ui icon orange mini button"
            [class.fiko-kilit]="!lisans('ANALIZ','radius')"
            style="padding: 0;"
            (click)="acFikoRadiusAnaliziDialog()"
            title="FikoYT Radius Analizi"> <img src="/simgeler/vektor-sec.webp"
             style="width: 22px !important; height: 22px; object-fit: contain;"> </button>

    <button class="circular ui icon purple mini button"
            [class.fiko-kilit]="!lisans('GORUNTULEME','kesit_gorunum')"
            (click)="acFikoKesitDialog()"
            title="Fiko-Kesit">
            <i class="cut icon"></i>
    </button>

    <button class="circular ui icon yellow mini button"
            (click)="openCSS3DAnnotationDialog()"
            title="Annotation Araçları"
            style="padding: 0;">
        <i class="icon comment alternate"
           style="height: 22px;width: 22px;line-height: 22px;"></i>
    </button>

    <!-- 🖼️ Resimden 3D (ComfyUI / FikoYT-img2-3d) -->
    <button id="butonFikoAi3D"
            class="circular ui icon mini button"
            (click)="acFikoAi3DDialog()"
            title="Resimden 3D — resim seç, yapay zekâ dokulu 3D modeli sahneye eklesin"
            style="padding: 0; background: linear-gradient(135deg, #7c3aed 0%, #ec4899 100%); color:#fff;">
        <i class="icon magic"
           style="height: 22px;width: 22px;line-height: 22px;"></i>
    </button>

    <button class="circular ui icon mini button"
            (click)="parcaTakipAc()"
            title="📦 Parça Takip — STP aç, tanı, üretimden sevkiyata izle"
            style="padding: 0; background:#1d4ed8; color:#fff;">
        <i class="icon box" style="height: 22px;width: 22px;line-height: 22px;"></i>
    </button>

    <!-- GD&T / Geometrik Tolerans Toolbar Butonu - Şimdilik gizli
    <button class="circular ui icon purple mini button"
            (click)="acAnnotationToolbar()"
            title="GD&T Araçları (Geometrik Tolerans, Datum, vb.)"
            style="padding: 0;">
        <i class="icon crosshairs"
           style="height: 22px;width: 22px;line-height: 22px;"></i>
    </button>
    -->

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('ANALIZ','dokum')"
            (click)="acFikoDFMDialog()"
            title="DFM Analizi (Üretilebilirlik)"
            style="padding: 0; background: linear-gradient(135deg, #FF6B00 0%, #FFD700 50%, #00FF88 100%);">
        <i class="icon flask"
           style="height: 22px;width: 22px;line-height: 22px; color: white;"></i>
    </button>

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('ACILI_KAFA','diagonal')"
            (click)="acKocKafaDialog()"
            title="Diagonal Kafa (WTEC)"
            style="padding: 0;">
        <img src="/simgeler/diagonal-kafa.svg"
             style="width: 22px; height: 22px; object-fit: contain;">
    </button>

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('ACILI_KAFA','ozmo')"
            (click)="acOzmoKafaDialog()"
            title="Ozmo Kafa"
            style="padding: 0;">
        <img src="/simgeler/ozmo-kafa.svg"
             style="width: 22px; height: 22px; object-fit: contain;">
    </button>

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('CIZIM','cizgi_3d')"
            (click)="ac3DLineDialog()"
            title="3D Çizgi"
            style="padding: 0;">
        <i class="pencil icon"
           style="height: 22px; width: 22px; line-height: 22px;"></i>
    </button>

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('CIZIM','cizgi_3d')"
            (click)="ac3DPolylineDialog()"
            title="3D Polyline"
            style="padding: 0; background: linear-gradient(135deg, #00AAAA 0%, #00FFFF 100%);">
        <i class="share alternate icon"
           style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
    </button>

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('CIZIM','cizgi_3d')"
            (click)="ac3DSplineDialog()"
            title="3D Spline (Catmull-Rom / Bezier)"
            style="padding: 0; background: linear-gradient(135deg, #FFA500 0%, #FF6600 100%);">
        <i class="wave square icon"
           style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
    </button>

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('CAM','cam_2d')"
            (click)="ac2DCamDialog()"
            title="2D CAM Sistemi"
            style="padding: 0; background: linear-gradient(135deg, #FF6B35 0%, #FF8C42 50%, #FFB347 100%);">
        <i class="microchip icon"
           style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
    </button>

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('OLCUM','cmm_tarama')"
            (click)="acCMMTaramaDialog()"
            title="Canlı Tarama (Mobil Kamera)"
            style="padding: 0; background: linear-gradient(135deg, #00E5FF 0%, #00B8D4 100%);">
        <i class="camera icon"
           style="height: 22px; width: 22px; line-height: 22px; color: #000;"></i>
    </button>

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('GORUNTULEME','ar_modu')"
            (click)="arModuToggle()"
            title="AR Modu (Kamera Arka Plan)"
            style="padding: 0;"
            [style.background]="arModuAktif ? 'linear-gradient(135deg, #FF6B00 0%, #FF3D00 100%)' : 'linear-gradient(135deg, #7C4DFF 0%, #651FFF 100%)'">
        @if (arModuAktif) {
        <i class="icon video"
           style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
        } @else {
        <i class="icon eye"
           style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
        }
    </button>

    <button class="circular ui icon mini button"
            [class.fiko-kilit]="!lisans('ANALIZ','dokum_kontrol')"
            (click)="acDokumKontrolDialog()"
            title="Döküm Kontrol"
            style="padding: 0; background: linear-gradient(135deg, #FF4500 0%, #FF8C00 50%, #FFD700 100%);">
        <i class="fire icon"
           style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
    </button>

    <!-- Üretim & Maliyet: 12 katma-değer modülü tek menüde (declutter) -->
    <button class="circular ui icon mini button"
            (click)="acUretimMenu()"
            title="Üretim & Maliyet (Teklif, CAM, Nesting, Kesim, Büküm, Kaplama, FAI, DXF…)"
            style="padding: 0; background: linear-gradient(135deg, #0a84c0 0%, #0bb39e 100%);">
        <i class="industry icon"
           style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
    </button>

        <!-- NPR Modları -->
        <button class="circular ui icon tiny button"
                (click)="degistirNPRModu('pbr')"
                title="Normal (PBR) Render"
                [class.active]="aktifNPRMod === 'pbr'"
                style="padding: 0; background-color: #5bbd72;">
            <i class="cube icon" style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
        </button>
        <button class="circular ui icon tiny button"
                [class.fiko-kilit]="!lisans('GORUNTULEME','render')"
                (click)="degistirNPRModu('gooch')"
                title="Gooch (Teknik Çizim) Render"
                [class.active]="aktifNPRMod === 'gooch'"
                style="padding: 0; background-color: #2185d0;">
            <i class="pencil alternate icon" style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
        </button>
        <button class="circular ui icon tiny button"
                [class.fiko-kilit]="!lisans('GORUNTULEME','render')"
                (click)="degistirNPRModu('toon')"
                title="Toon (Çizgi Film) Render"
                [class.active]="aktifNPRMod === 'toon'"
                style="padding: 0; background-color: #fbbd08;">
            <i class="paint brush icon" style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
        </button>
        <button class="circular ui icon tiny button"
                [class.fiko-kilit]="!lisans('GORUNTULEME','render')"
                (click)="degistirNPRModu('hatching')"
                title="Hatching (Tarama Çizgileri) Render"
                [class.active]="aktifNPRMod === 'hatching'"
                style="padding: 0; background-color: #a333c3;">
            <i class="grip lines icon" style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
        </button>
        <button class="circular ui icon tiny button"
                [class.fiko-kilit]="!lisans('GORUNTULEME','render')"
                (click)="degistirNPRModu('silhouette')"
                title="Silhouette (Dış Hat) Render"
                [class.active]="aktifNPRMod === 'silhouette'"
                style="padding: 0; background-color: #e03997;">
            <i class="vector square icon" style="height: 22px; width: 22px; line-height: 22px; color: white;"></i>
        </button>

    @if ((fikoThreejs.aktifItem?.solAracCubugu ?? []).length>0) {
    <div style="border-bottom: 1px solid white;height: 2px;width: 100%;"></div>
    }

    @for (item of fikoThreejs.aktifItem?.solAracCubugu ?? []; track $index) {

    <span style="display: flex; align-items: center;">
        @switch (item.tipi) {

        @case ('Ayraç') {
        <span>
            <span style="border-left: 1px solid white;"></span>
        </span>
        }
        @default {
        <button class="circular ui icon {{ item.renkSinif ?? 'green' }} tiny button"
                style="padding: 0 !important;"
                [title]="item.baslik"
                (click)="item.tiklandi ? item.tiklandi():null;">
            @if (item.simge) {
            <i class="icon {{ item.simge }}"
               style="height: 22px;width: 22px;line-height: 20px;"></i>
            }
            @if (item.simgeYazi) {
            <i class="icon"
               style="height: 22px;width: 22px;line-height: 22px;">{{item.simgeYazi}}</i>
            }
            @if (item.resim) {
            <img [src]="item.resim"
                 style="width: 22px !important; height: 22px; object-fit: contain;">
            }
        </button>
        }
        }

    </span>
    }

    <!-- Progress ve Mesaj UI - Minimal & Animated -->
    @if (yuklemeDurumu.aktif) {
    <div class="progress-container"
         style="position: fixed;top:30px;">
        <!-- Progress Bar (ana bar) -->
        <div class="progress-bar-bg">
            <div class="progress-bar-fill"
                 [style.width.%]="yuklemeDurumu.progress"></div>
        </div>

        <!-- Mesaj ve Yüzde (tek satır) -->
        <div class="progress-info">
            <span class="progress-message">{{yuklemeDurumu.mesaj}}</span>
            <span class="progress-percent">%{{yuklemeDurumu.progress.toFixed(0)}}</span>
        </div>
    </div>
    }
</div>
}

<div id="dialogCncProgramciSolMenu"
     [style.visibility]="solAracCubuguAcik ? 'visible':'hidden'"
     [style.pointer-events]="listeModuAktif ? 'all':'none'"
     style="position: absolute;top: 35px;left:0px;width:100%;max-width:100%;bottom: 0;background: rgba(255,255,255,0.0);min-height:150px;border-right:1px solid transparent;padding-left:32px;padding-right:5px;overflow: auto;pointer-events: none;z-index: 10;"
     (click)="onTreeContainerClick($event)">

    <div class="ui mini"
         style="white-space: nowrap;width: min-content;">

        <div class="urunAgaci">

            <div class="agac-arama">
                <i class="icon search"></i>
                <input type="text" [(ngModel)]="agacArama" placeholder="Ağaçta ara…" />
                @if(agacArama){ <i class="icon times" (click)="agacArama=''" title="Temizle"></i> }
            </div>

            <fikoyt-agac-item
                [grup]="fikoThreejs?.sahneler[0]?.urunAgaci"
                [selectionState]="fikoThreejs?.sahneler[0]?.secimler?.treeSelectionState"
                [agacArama]="agacArama"
                (treeHover)="onTreeItemHover($event)"
                (treeSelect)="onTreeItemSelect($event)"
                (treeReorder)="onTreeReorder($event)">
            </fikoyt-agac-item>

        </div>

    </div>
</div>


<!-- Ribbon komut flyout'u (ilgili komutlar tek buton altında — ribbon kalabalığını önler) -->
@if(modellemeAcik && ribbonFlyout){
  <div class="wb-menu wb-menu-kok" [style.left.px]="ribbonFlyout.x" [style.top.px]="ribbonFlyout.y">
    @for(o of ribbonFlyout.ogeler; track o.ad){
      <button class="wb-menu-item" (click)="ribbonFlyoutSec(o)"><i class="icon {{o.ikon}}"></i><span>{{o.ad}}</span></button>
    }
  </div>
}

<!-- Workbench seçici menüsü — KÖK seviyede (ribbon overflow'undan kaçar, yukarı açılır) -->
@if(modellemeAcik && workbenchAcik){
  <div class="wb-menu wb-menu-kok" [style.left.px]="wbMenuPos.x" [style.top.px]="wbMenuPos.y">
    @for(w of modellemeWorkbenchler; track w.id){
      <button class="wb-menu-item" [class.aktif]="w.id===modellemeWorkbench" (click)="workbenchSec(w.id)">
        <i class="icon {{w.ikon}}" [style.color]="w.renk"></i>
        <span>{{w.ad}}</span>
        @if(w.id===modellemeWorkbench){ <i class="icon check wb-menu-tik"></i> }
      </button>
    }
  </div>
}

<!-- Ağır CSG işlemi göstergesi -->
@if(modellemeMesgul){
  <div class="mdl-mesgul"><div class="mdl-mesgul-ic"><i class="icon spinner loading"></i> Hesaplanıyor…</div></div>
}

<!-- CATIA tarzı komut penceresi (canlı önizleme + Tamam/İptal) -->
@if(mdlKomutAcik){
  <fikoyt-komut-penceresi [tanim]="mdlKomutAcik" [yonetici]="modellemeAl()" (kapat)="mdlKomutKapat()"></fikoyt-komut-penceresi>
}

<!-- ✏️ Workbench Ribbon — alt toolbar üstünde, aktif workbench'e göre dinamik (CATIA tarzı) -->
@if(modellemeAcik){
<div class="mdl-wb-cubugu">
  <!-- Workbench seçici (CATIA tarzı) -->
  <div class="wb-secici">
    <button class="wb-rozet" (click)="workbenchToggle($event)" [style.--wb-renk]="modellemeWorkbenchBilgi.renk" title="Workbench değiştir">
      <i class="icon {{modellemeWorkbenchBilgi.ikon}} wb-rozet-ik"></i>
      <span class="wb-rozet-ad">{{modellemeWorkbenchBilgi.ad}}</span>
      <i class="icon angle up wb-cevron" [class.acik]="workbenchAcik"></i>
    </button>
  </div>
  <div class="wb-ayrac"></div>
  <div class="wb-grup">
    <div class="wb-btnlar">
      <button class="wb-cmd" [disabled]="!geriAlinabilir()" (click)="modellemeGeriAl()" title="Geri Al (Ctrl+Z)"><i class="icon undo"></i><span>Geri Al</span></button>
      <button class="wb-cmd" [disabled]="!ileriAlinabilir()" (click)="modellemeIleriAl()" title="İleri Al (Ctrl+Y)"><i class="icon redo"></i><span>İleri Al</span></button>
    </div>
    <div class="wb-etiket">Geçmiş</div>
  </div>
  <div class="wb-ayrac"></div>
  @if(modellemeDurum === 'kapali'){
    <!-- CAM workbench: gerçek CAM motoru (Profil/Cep/Delik/Gravür + G-code) — 2D CAM paneline bağlı -->
    @if(modellemeWorkbench === 'cam'){
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd teal" (click)="camAktivite('profil')" title="Profil / Çevre İşleme (contouring)"><i class="icon crosshairs"></i><span>Profil</span></button>
          <button class="wb-cmd teal" (click)="camAktivite('cep')" title="Cep Açma (pocket milling)"><i class="icon clone outline"></i><span>Cep</span></button>
          <button class="wb-cmd teal" (click)="camAktivite('delik')" title="Delik İşlemleri (drilling)"><i class="icon dot circle outline"></i><span>Delik</span></button>
          <button class="wb-cmd green" (click)="camDelikBul()" title="Otomatik Delik Tanıma — B-Rep silindirik yüzlerden matkap operasyonları oluştur"><i class="icon magic"></i><span>Delik Bul</span></button>
          <button class="wb-cmd teal" (click)="camAktivite('gravur')" title="Gravür / Yazı (engraving)"><i class="icon pen square"></i><span>Gravür</span></button>
          <button class="wb-cmd" (click)="ac2DCamDialog()" title="2D CAM Paneli (tüm işlemler + G-code)"><i class="icon sliders horizontal"></i><span>CAM Paneli</span></button>
        </div>
        <div class="wb-etiket">2D İşleme</div>
      </div>
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd orange" (click)="mdlKomutAc('cam3d_roughing')" title="Z-Level Kaba İşleme — parametre + canlı toolpath önizleme"><i class="icon layer group"></i><span>Kaba</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('cam3d_parallel')" title="Parallel Finiş — takım/scallop/yön ayarı + canlı önizleme"><i class="icon align justify"></i><span>Parallel</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('cam3d_waterline')" title="Waterline Finiş — sabit-Z kontur (dik duvar)"><i class="icon water"></i><span>Waterline</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('cam3d_pencil')" title="Pencil — iç konkav köşe/oluk temizliği"><i class="icon pencil"></i><span>Pencil</span></button>
          <button class="wb-cmd blue" [class.fiko-kilit]="!lisans('CAM','simulasyon')" (click)="cam3dSimulasyonAc()" title="Kütük Simülasyonu — son toolpath ile talaş kaldırmayı izle"><i class="icon play circle"></i><span>Simüle</span></button>
          <button class="wb-cmd green" [class.fiko-kilit]="!lisans('CAM','nc_post')" (click)="cam3dGcodeIndir()" title="Son toolpath'i ISO G-code (.nc) indir"><i class="icon download"></i><span>G-Code</span></button>
          <button class="wb-cmd" (click)="cam3dTemizle()" title="Toolpath görselini temizle"><i class="icon eraser"></i><span>Temizle</span></button>
        </div>
        <div class="wb-etiket">3D Frezeleme</div>
      </div>
      <div class="wb-ayrac"></div>
    }
    <!-- 2D CAM workbench (CATIA Prismatic Machining): operasyonlar ürün ağacına eklenir, sağ panel YOK -->
    @if(modellemeWorkbench === '2dcam'){
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd purple" (click)="camPartOpAc()" title="Parça Operasyonu kurulumu: makine · work offset (G54-G59) · malzeme · güvenlik Z · stok · eksen orijini"><i class="icon industry"></i><span>Setup</span></button>
          <button class="wb-cmd" (click)="camStok()" title="Stok kütüğünü otomatik oluştur (gövde bbox)"><i class="icon th large"></i><span>Stok</span></button>
          <button class="wb-cmd teal" (click)="camHesapla()" [style.box-shadow]="cam?.bayatVar ? '0 0 8px #ffb02e' : null" [title]="cam?.bayatVar ? 'Model değişti — güncel olmayan (⟳) takım yolları var, hesaplayın' : 'Tüm operasyonların takım yolunu hesapla'"><i class="icon cogs"></i><span>{{ cam?.bayatVar ? '⟳ Güncelle' : 'Hesapla' }}</span></button>
          <button class="wb-cmd" (click)="camOtoToggle()" [style.color]="cam?.otoGuncelle ? '#00d0ff' : null" title="CATIA update modu: model değişince toolpath'leri otomatik güncelle / manuel ⟳ işaretle"><i class="icon sync alternate"></i><span>{{ cam?.otoGuncelle ? 'Oto' : 'Manuel' }}</span></button>
          <button class="wb-cmd orange" [class.fiko-kilit]="!lisans('CAM','simulasyon')" (click)="camReplay()" title="Takım yolu animasyonu (replay)"><i class="icon play"></i><span>Replay</span></button>
          <button class="wb-cmd blue" [class.fiko-kilit]="!lisans('CAM','simulasyon')" (click)="camSimule()" title="Kütük simülasyonu (talaş kaldırma)"><i class="icon play circle"></i><span>Simüle</span></button>
          <button class="wb-cmd" (click)="camGougeKontrol()" title="Gouge / çarpma statik kontrolü"><i class="icon shield alternate"></i><span>Gouge</span></button>
          <button class="wb-cmd amber" (click)="camYeniTakim()" title="Yeni takım ekle + grafiksel takım tanımı (CATIA Tool Definition)"><i class="icon wrench"></i><span>Takım+</span></button>
        </div>
        <div class="wb-etiket">Program</div>
      </div>
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          @for(t of camFrezeTipler; track t){
            <button class="wb-cmd" (click)="camOpEkle(t)" title="{{camOpAd(t)}}"><i class="icon {{camOpIkon(t)}}"></i><span>{{camOpKisa(t)}}</span></button>
          }
        </div>
        <div class="wb-etiket">Frezeleme</div>
      </div>
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          @for(k of camAxialKat; track k.ad){
            <button class="wb-cmd orange" [class.acik]="camAcikKat===k.ad" (click)="camKatToggle(k.ad, $event)" [title]="k.ad"><i class="icon {{k.ikon}}"></i><span>{{k.ad}} ▾</span></button>
          }
        </div>
        <div class="wb-etiket">Eksenel · Delik</div>
      </div>
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd green" [class.fiko-kilit]="!lisans('CAM','nc_post')" (click)="camCiktiGoster('apt')" title="APT üret — birincil NC ara formatı (makineden bağımsız, CYCLE/MULTAX/CUTCOM tam)"><i class="icon file alternate outline"></i><span>APT</span></button>
          <button class="wb-cmd" [class.fiko-kilit]="!lisans('CAM','nc_post')" (click)="camCiktiGoster('gcode')" title="ISO G-code (Fanuc) üret — ikincil çıktı"><i class="icon file code outline"></i><span>G-code</span></button>
          <button class="wb-cmd" (click)="camCiktiGoster('dok')" title="Operasyon dokümanı"><i class="icon file outline"></i><span>Doküman</span></button>
        </div>
        <div class="wb-etiket">Çıktı</div>
      </div>
      <div class="wb-ayrac"></div>
    }
    @else if(modellemeWorkbench !== 'part' && modellemeWorkbench !== 'sketcher' && modellemeWorkbench !== '2dcam' && modellemeWorkbench !== 'cam'){
      <!-- Meslek workbench'leri (Tesisat / Takı / Mimarlık / Çelik …): veri-odaklı makro komutlar -->
      <div class="wb-grup">
        <div class="wb-btnlar">
          @for(k of modellemeMakroKomutlar; track k.id){
            <button class="wb-cmd teal" (click)="mdlKomutAc(k.id)" title="{{k.etiket}}"><i class="icon {{k.ikon}}"></i><span>{{k.etiket}}</span></button>
          }
        </div>
        <div class="wb-etiket">{{modellemeWorkbenchBilgi.ad}}</div>
      </div>
      <div class="wb-ayrac"></div>
    }
    <!-- PART DESIGN workbench (CATIA mantığı): katı modelleme — eskiz başlat + primitif + feature + dönüşüm. Sadece part workbench'inde görünür. -->
    @if(modellemeWorkbench === 'part'){
    <div class="wb-grup">
      <div class="wb-btnlar">
        <button class="wb-cmd teal" [class.fiko-kilit]="!lisans('CIZIM','sketch')" (click)="mdlKomutAc('sketch')" title="Eskiz — pencereden düzlem (XY/XZ/YZ) ya da yüz seç (CATIA gibi)"><i class="icon pencil alternate"></i><span>Eskiz</span></button>
        <button class="wb-cmd teal" (click)="mdlKomutAc('refDuzlem')" title="Referans Düzlem — offset datum düzlem oluştur (çift-tık ile üzerine sketch)"><i class="icon clone outline"></i><span>Ref. Düzlem</span></button>
        <button class="wb-cmd" (click)="modellemeGeometriSeti()" title="Geometrik Set — referans geometri (düzlem/eksen/nokta) için yeni container (CATIA)"><i class="icon object group"></i><span>Geo. Set</span></button>
        <button class="wb-cmd" (click)="modellemeBodyEkle()" title="Body Ekle — yeni katı gövde (CATIA Insert > Body). Aktif olur, sonraki özellikler altına eklenir."><i class="icon cube"></i><span>Body</span></button>
        <button class="wb-cmd teal" (click)="modellemeYazi3D()" title="3D Yazı — metin/font/boyut/kalınlık ile katı yazı"><i class="icon font"></i><span>3D Yazı</span></button>
      </div>
      <div class="wb-etiket">Eskiz</div>
    </div>
    <div class="wb-ayrac"></div>
    <div class="wb-grup">
      <div class="wb-btnlar">
        <button class="wb-cmd" [class.fiko-kilit]="!lisans('CIZIM','parametrik')" (click)="mdlKomutAc('kutu')" title="Kutu (parametrik)"><i class="icon cube"></i><span>Kutu</span></button>
        <button class="wb-cmd" [class.fiko-kilit]="!lisans('CIZIM','parametrik')" (click)="mdlKomutAc('silindir')" title="Silindir (parametrik)"><i class="icon circle"></i><span>Silindir</span></button>
        <button class="wb-cmd" [class.fiko-kilit]="!lisans('CIZIM','parametrik')" (click)="mdlKomutAc('kure')" title="Küre (parametrik)"><i class="icon globe"></i><span>Küre</span></button>
        <button class="wb-cmd" [class.fiko-kilit]="!lisans('CIZIM','parametrik')" (click)="mdlKomutAc('koni')" title="Koni (parametrik)"><i class="icon play"></i><span>Koni</span></button>
        <button class="wb-cmd teal" [class.fiko-kilit]="!lisans('GORUNTULEME')" (click)="modellemeStepKusursuz()" title="STEP/STP içe aktar — KUSURSUZ B-Rep gövde (üstüne pocket/fillet/shell uygulanabilir)"><i class="icon download"></i><span>STP İçe Aktar</span></button>
      </div>
      <div class="wb-etiket">Primitif Katı</div>
    </div>
    <div class="wb-grup">
      <div class="wb-btnlar">
        <select class="wb-secim" [value]="mdlAktifKalite" (change)="mdlMeshKalite($any($event.target).value)" title="CATIA 3D Accuracy — görüntü mesh kalitesi (B-Rep korunur, hesap etkilenmez)">
          <option value="kaba">Kaba</option>
          <option value="orta">Orta</option>
          <option value="ince">İnce</option>
          <option value="cokInce">Çok İnce</option>
          <option value="ozel" disabled>Özel</option>
        </select>
        <input type="range" class="wb-slider" min="0.0002" max="0.02" step="0.0002"
               [value]="mdlKaliteOran" (input)="mdlMeshKaliteSayisal($any($event.target).value)"
               title="Sayısal hassasiyet (sag) — küçük = daha pürüzsüz, daha çok üçgen" />
        <input type="number" class="wb-secim wb-kalite-mm" min="0.0002" max="0.02" step="0.0002"
               [value]="mdlKaliteOran" (change)="mdlMeshKaliteSayisal($any($event.target).value)"
               title="Hassasiyet (mm)" />
      </div>
      <div class="wb-etiket">3D Kalite</div>
    </div>
    @if(modellemeHedefVar){
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd green" [class.fiko-kilit]="!lisans('CIZIM','parametrik')" (click)="modellemePad()" title="Pad — profili öteleyip ekle"><i class="icon level up alternate"></i><span>Pad</span></button>
          <button class="wb-cmd orange" [class.fiko-kilit]="!lisans('CIZIM','parametrik')" (click)="modellemePocket()" title="Pocket — profili öteleyip çıkar"><i class="icon level down alternate"></i><span>Pocket</span></button>
          <button class="wb-cmd green" (click)="modellemeShaft()" title="Shaft — döndürerek ekle"><i class="icon sync alternate"></i><span>Shaft</span></button>
          <button class="wb-cmd orange" (click)="modellemeGroove()" title="Groove — döndürerek çıkar"><i class="icon undo alternate"></i><span>Groove</span></button>
          <button class="wb-cmd orange" (click)="modellemeHole()" title="Delik — yüzeye tıkla, matkapla delik aç (havşa/V-dip/diş)"><i class="icon dot circle outline"></i><span>Delik</span></button>
          <button class="wb-cmd green" (click)="modellemeRib()" title="Rib — profili kalınlaştırıp uzatarak ekle (kaburga)"><i class="icon grip lines vertical"></i><span>Kaburga</span></button>
          <button class="wb-cmd green" (click)="mdlKomutAc('stiffener')" title="Feder (Stiffener) — açık profili kalınlaştırıp tabana indirerek destek ekle"><i class="icon caret square up"></i><span>Feder</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('loft')" title="Loft — 2+ kesit profili arasında pürüzsüz katı (kanat/huni)"><i class="icon layer group"></i><span>Loft</span></button>
          <button class="wb-cmd orange" (click)="mdlKomutAc('removedLoft')" title="Loft Çıkar — 2+ kesit arasında loft katısını gövdeden çıkar (CATIA Removed Multi-Section)"><i class="icon layer group"></i><span>Loft Çıkar</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('sweep')" title="Sweep — profili yol boyunca süpür (boru/kanal)"><i class="icon route"></i><span>Sweep</span></button>
          <button class="wb-cmd orange" (click)="mdlKomutAc('slot')" title="Slot — profili yol boyunca süpürüp çıkar (kanal/oluk)"><i class="icon minus"></i><span>Slot</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('combine')" title="Solid Combine — iki profilin kesişim hacmini katı yap"><i class="icon object group"></i><span>Birleştir</span></button>
        </div>
        <div class="wb-etiket">Part Design</div>
      </div>
    }
    @if(modellemeGovdeVar){
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd" (click)="mdlKomutAc('translate')" title="Taşı — gövdeyi X/Y/Z mesafe kadar öteler"><i class="icon arrows alternate"></i><span>Taşı</span></button>
          <button class="wb-cmd" (click)="mdlKomutAc('rotate')" title="Döndür — gövdeyi eksen etrafında açıyla döndürür"><i class="icon redo"></i><span>Döndür</span></button>
          <button class="wb-cmd" (click)="mdlKomutAc('symmetry')" title="Simetri — gövdeyi düzleme göre aynalanmış konuma taşır"><i class="icon clone outline"></i><span>Simetri</span></button>
          <button class="wb-cmd" (click)="mdlKomutAc('scaling')" title="Ölçekle — gövdeyi katsayıyla büyüt/küçült"><i class="icon expand arrows alternate"></i><span>Ölçekle</span></button>
          <button class="wb-cmd" (click)="mdlKomutAc('mirror')" title="Aynala — düzlem/seçili yüz pencerede seçilir"><i class="icon exchange"></i><span>Aynala</span></button>
          <button class="wb-cmd" (click)="mdlKomutAc('userPattern')" title="Nokta Dizi — gövdeyi tüm 3D noktalarda çoğalt (önce Surface → Nokta)"><i class="icon braille"></i><span>Nokta Dizi</span></button>
          <button class="wb-cmd" (click)="modellemePatternDik()" title="Doğrusal Dizi (4 kopya)"><i class="icon ellipsis horizontal"></i><span>Dizi</span></button>
          <button class="wb-cmd" (click)="modellemePatternIzgara()" title="Izgara Dizi (3×3)"><i class="icon th"></i><span>Izgara</span></button>
          <button class="wb-cmd" (click)="modellemePatternDairesel()" title="Dairesel Dizi (6 kopya)"><i class="icon asterisk"></i><span>Dairesel</span></button>
          <button class="wb-cmd orange" (click)="modellemeShell()" title="Kabuk — gövdeyi içi boş kabuk yap"><i class="icon box open"></i><span>Kabuk</span></button>
          <button class="wb-cmd" (click)="mdlKomutAc('thickness')" title="Kalınlık — gövdeye et kalınlığı ekle/çıkar (offset)"><i class="icon clone"></i><span>Kalınlık</span></button>
          <button class="wb-cmd orange" (click)="mdlKomutAc('split')" title="Böl — gövdeyi bir düzlemle kesip bir tarafını tut"><i class="icon cut"></i><span>Böl</span></button>
          <button class="wb-cmd orange" (click)="mdlKomutAc('removeFace')" title="Yüz Sil — 3D'de yüz(ler) seç, defeaturing ile kaldır"><i class="icon clone outline"></i><span>Yüz Sil</span></button>
          <button class="wb-cmd orange" (click)="mdlKomutAc('replaceFace')" title="Yüz Değiştir — seçili yüzü hedef düzleme taşı (Replace Face)"><i class="icon exchange"></i><span>Yüz Değiştir</span></button>
          <button class="wb-cmd orange" (click)="mdlKomutAc('removeLump')" title="Parça Sil — kopuk solid parçalardan en büyüğünü tut"><i class="icon eraser"></i><span>Parça Sil</span></button>
          <button class="wb-cmd" (click)="modellemeDraft()" title="Eğim — yüzeyleri açıyla eğ (draft)"><i class="icon sort amount down"></i><span>Eğim</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('fillet3d')" title="Kenar Yuvarlat — keskin kenarları fillet ile yuvarla"><i class="icon circle notch"></i><span>Yuvarlat</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('faceFillet')" title="Yüz Fillet — komşu 2 yüz seç, paylaştıkları kenara fillet (Face-Face)"><i class="icon circle notch"></i><span>Yüz Fillet</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('triFillet')" title="Tritangent Fillet — şerit/orta yüz seç, oto-yarıçapla tangent yuvarla"><i class="icon circle notch"></i><span>Tritangent</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('chamfer3d')" title="Kenar Pah — keskin kenarlara chamfer (pah)"><i class="icon cut"></i><span>Pah</span></button>
        </div>
        <div class="wb-etiket">Dönüşüm</div>
      </div>
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd teal" (click)="modellemeYeniGovde()" title="Yeni Gövde — 2. bağımsız gövde oluştur (Boolean için)"><i class="icon plus square outline"></i><span>Yeni Gövde</span></button>
          <button class="wb-cmd green" (click)="modellemeBool('add')" title="Ekle (Union) — aktif gövdeyi ana gövdeye ekle"><i class="icon plus circle"></i><span>Ekle</span></button>
          <button class="wb-cmd orange" (click)="modellemeBool('remove')" title="Çıkar (Cut) — aktif gövdeyi ana gövdeden çıkar"><i class="icon minus circle"></i><span>Çıkar</span></button>
          <button class="wb-cmd teal" (click)="modellemeBool('intersect')" title="Kesiştir (Common) — iki gövdenin ortak hacmi"><i class="icon adjust"></i><span>Kesiştir</span></button>
        </div>
        <div class="wb-etiket">Gövde & Boolean</div>
      </div>
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd teal" (click)="mdlKomutAc('malzeme')" title="Malzeme Ata — yoğunluk → ağırlık + renk (CATIA)"><i class="icon tint"></i><span>Malzeme</span></button>
          <button class="wb-cmd teal" (click)="modellemeParametreler()" title="Parametreler — merkezi parametre yönetimi (grup, formül, tasarım tablosu, kontrol)"><i class="icon sliders horizontal"></i><span>Parametreler</span></button>
          <button class="wb-cmd" [class.fiko-kilit]="!lisans('GORUNTULEME','xray')" [class.aktif]="ribbonFlyout?.ad==='gorunum'" (click)="ribbonFlyoutToggle('gorunum',$event)" title="Görünüm Modu — Dolu / Tel Kafes / Yarı Saydam (X-Ray)"><i class="icon eye"></i><span>Görünüm ▾</span></button>
        </div>
        @if(modellemeGovdeBilgi; as gb){
          <div class="wb-dof tam" [title]="gb.malzeme + ' · ' + gb.hacimCm3 + ' cm³ · ' + gb.agirlikG + ' g'">
            <i class="icon balance scale"></i><span>{{ modellemeAgirlikStr }}</span>
          </div>
        }
        <div class="wb-etiket">Malzeme & Ağırlık</div>
      </div>
    }
    }
    <!-- SURFACE (GSD) workbench: wireframe + yüzey oluştur + yüzey operasyonları -->
    @if(modellemeWorkbench === 'surface'){
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd teal" [class.fiko-kilit]="!lisans('CIZIM','sketch')" (click)="mdlKomutAc('sketch')" title="Eskiz — profil çizmek için düzlem (XY/XZ/YZ) ya da yüz seç"><i class="icon pencil alternate"></i><span>Eskiz</span></button>
          <button class="wb-cmd teal" (click)="mdlKomutAc('refDuzlem')" title="Referans Düzlem — offset datum düzlem"><i class="icon clone outline"></i><span>Ref. Düzlem</span></button>
        </div>
        <div class="wb-etiket">Eskiz</div>
      </div>
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd" (click)="modellemeNokta3d()" title="3D Nokta — Koordinat / Arası / Eğride / Uç / Düzlemde / İzdüşüm / Yüze tıkla"><i class="icon dot circle"></i><span>Nokta</span></button>
          <button class="wb-cmd" [class.aktif]="ribbonFlyout?.ad==='egri'" (click)="ribbonFlyoutToggle('egri',$event)" title="Eğriler — Çizgi / Çember / Spline / Helis / Spiral / Paralel / Bağlantı"><i class="icon bezier curve"></i><span>Eğri ▾</span></button>
          <button class="wb-cmd" (click)="modellemeDuzlem3d()" title="Düzlem — Ofset / 3 Nokta / Eğriye Normal / Noktadan Paralel / İki Çizgi"><i class="icon clone outline"></i><span>Düzlem</span></button>
        </div>
        <div class="wb-etiket">Tel Kafes (Wireframe)</div>
      </div>
      @if(modellemeHedefVar){
        <div class="wb-ayrac"></div>
        <div class="wb-grup">
          <div class="wb-btnlar">
            <button class="wb-cmd teal" (click)="modellemeYuzey('Extrude')" title="Yüzey Uzat — profili yön boyunca uzatıp açık yüzey"><i class="icon clone outline"></i><span>Uzat</span></button>
            <button class="wb-cmd teal" (click)="modellemeYuzey('Revolve')" title="Yüzey Döndür — profili eksen etrafında döndür"><i class="icon sync"></i><span>Döndür</span></button>
            <button class="wb-cmd teal" (click)="modellemeYuzey('Fill')" title="Dolgu Yüzey — kapalı profili doldur"><i class="icon square outline"></i><span>Dolgu</span></button>
            <button class="wb-cmd teal" (click)="modellemeYuzey('Loft')" title="Çok-Kesit Yüzey — kesitler arası pürüzsüz"><i class="icon layer group"></i><span>Çok-Kesit</span></button>
            <button class="wb-cmd teal" (click)="modellemeYuzey('Sweep')" title="Süpürme Yüzey — profili yol boyunca süpür"><i class="icon route"></i><span>Süpür</span></button>
            <button class="wb-cmd green" (click)="mdlKomutAc('closeSurface')" title="Yüzey Kapat — açık yüzeyleri dikip kapalı katı yap (Close Surface)"><i class="icon object group"></i><span>Katı Yap</span></button>
          </div>
          <div class="wb-etiket">Yüzey Oluştur</div>
        </div>
      }
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-btnlar">
          <button class="wb-cmd" [class.aktif]="ribbonFlyout?.ad==='yuzeyislem'" (click)="ribbonFlyoutToggle('yuzeyislem',$event)" title="Yüzey İşlemleri — Paralel / Kalınlaştır / Böl / Sınır / Birleştir"><i class="icon clone outline"></i><span>İşlem ▾</span></button>
        </div>
        <div class="wb-etiket">Yüzey İşlem</div>
      </div>
    }
  }
  @if(modellemeDurum === 'yuz-secimi'){
    <div class="wb-grup">
      <div class="wb-btnlar">
        <button class="wb-cmd yellow mdl-nabiz" title="Bir yüze tıkla…"><i class="icon hand pointer"></i><span>Yüz seç</span></button>
        <button class="wb-cmd red" (click)="modellemeIptal()" title="Vazgeç"><i class="icon times"></i><span>Vazgeç</span></button>
      </div>
      <div class="wb-etiket">Yüz Seçimi</div>
    </div>
  }
  @if(modellemeDurum === 'sketch'){
    <div class="wb-grup">
      <div class="wb-btnlar">
        <button class="wb-cmd" [class.wb-aktif]="modellemeAktifArac==='sec'" (click)="modellemeArac('sec')" title="Seç (Esc)"><i class="icon mouse pointer"></i><span>Seç</span></button>
        <div class="mdl-fly">
          <button class="wb-cmd wb-fly-btn" [class.wb-aktif]="mdlProfilAktif" (click)="mdlFlyoutToggle('profil', $event)" title="Profil — {{mdlSonProfil.etiket}}">
            <i class="icon {{mdlSonProfil.ikon}}"></i><span>{{mdlSonProfil.etiket}}</span><span class="mdl-ok"></span>
          </button>
        </div>
        <div class="mdl-fly">
          <button class="wb-cmd wb-fly-btn" (click)="mdlFlyoutToggle('operasyon', $event)" title="Operasyon — {{mdlSonOperasyon.etiket}}">
            <i class="icon {{mdlSonOperasyon.ikon}}"></i><span>{{mdlSonOperasyon.etiket}}</span><span class="mdl-ok"></span>
          </button>
        </div>
        <div class="mdl-fly">
          <button class="wb-cmd wb-fly-btn" (click)="mdlFlyoutToggle('kisit', $event)" title="Kısıt — {{mdlSonKisit.etiket}}">
            <i class="icon {{mdlSonKisit.ikon}}"></i><span>Kısıt</span><span class="mdl-ok"></span>
          </button>
        </div>
      </div>
      <div class="wb-etiket">Profil & Kısıt</div>
    </div>
    <div class="wb-ayrac"></div>
    <div class="wb-grup">
      <div class="wb-btnlar">
        <button class="wb-cmd" (click)="modellemeOlcu()" title="Ölçülendir — eleman seç, etikete çift-tıkla değiştir"><i class="icon arrows alternate horizontal"></i><span>Ölçü</span></button>
        <button class="wb-cmd teal" (click)="modellemeOtoKisit()" title="Otomatik Kısıtla — tüm geometriye yatay/dikey/çakışık kısıt çıkar (CATIA Auto Constraint)"><i class="icon magic"></i><span>Oto Kısıt</span></button>
        <button class="wb-cmd teal" (click)="modellemeOtoOlcu()" title="Otomatik Ölçü — çizgi boyu/çember yarıçapı + konum sabitle, sketch'i tam tanımla (CATIA Auto Dimension)"><i class="icon ruler combined"></i><span>Oto Ölçü</span></button>
        <button class="wb-cmd" (click)="modellemeSketchAnaliz()" title="Sketch Analizi — açık profil/serbest uç tespiti (neden pad olmuyor?)"><i class="icon heartbeat"></i><span>Analiz</span></button>
        <button class="wb-cmd" [class.wb-aktif]="modellemeAnimAktif" (click)="modellemeAnimasyon()" title="Animasyon — seçili ölçüyü oynat, mekanizmayı izle (CATIA Animate Constraint)"><i class="icon play"></i><span>Animasyon</span></button>
        <button class="wb-cmd" (click)="modellemeEskizDuzlemCycle()" title="Eskiz Düzlemi — eskizi XY/XZ/YZ düzlemine taşı (CATIA Change Support)"><i class="icon sync"></i><span>Düzlem</span></button>
        <button class="wb-cmd" (click)="modellemeDikBak()" title="Sketch'e dik bak (Normal View)"><i class="icon eye"></i><span>Dik Bak</span></button>
        <button class="wb-cmd" [class.wb-aktif]="modellemeGrid" (click)="modellemeGridToggle()" title="Grid"><i class="icon th"></i><span>Grid</span></button>
      </div>
      <div class="wb-etiket">Kısıt & Görünüm</div>
    </div>
    @if(modellemeGovdeVar){
    <div class="wb-ayrac"></div>
    <div class="wb-grup">
      <div class="wb-btnlar">
        <button class="wb-cmd teal" [class.wb-aktif]="modellemeProjekteAktif" (click)="modellemeProjekte3d()" title="3D Yansıt — katı kenarını aktif eskize inşa çizgisi olarak izdüşür (CATIA Project 3D Element)"><i class="icon download"></i><span>3D Yansıt</span></button>
        <button class="wb-cmd teal" (click)="modellemeIntersect3d()" title="3D Kesişim — katının eskiz düzlemiyle kesişim eğrilerini eskize düşür (CATIA Intersect 3D Element)"><i class="icon sitemap"></i><span>Kesişim</span></button>
        <button class="wb-cmd" [class.wb-aktif]="modellemeKesitAktif" (click)="modellemeKesit()" title="Kesit — eskiz düzlemiyle katıyı görsel kes, içte çiz (CATIA Cut Part by Sketch Plane)"><i class="icon expand"></i><span>Kesit</span></button>
        @if(modellemeKesitAktif){ <button class="wb-cmd" (click)="modellemeKesitYon()" title="Kesit yönünü çevir"><i class="icon exchange"></i><span>Yön</span></button> }
      </div>
      <div class="wb-etiket">3D Referans</div>
    </div>
    }
    <div class="wb-grup">
      <div class="wb-btnlar">
        <button class="wb-cmd blue" (click)="modellemeBitir()" title="Sketch'i bitir → Part Design'da Pad/Pocket ile profili seç (CATIA mantığı)"><i class="icon check"></i><span>Bitir</span></button>
        <button class="wb-cmd red" (click)="modellemeIptal()" title="İptal (sketch'i sil)"><i class="icon trash alternate"></i><span>İptal</span></button>
      </div>
      <div class="wb-etiket">Tamamla</div>
    </div>
    @if(modellemeDurumOzeti; as d){
      <div class="wb-ayrac"></div>
      <div class="wb-grup">
        <div class="wb-dof" [class.tam]="d.durum === 'tam'" [class.asiri]="d.durum === 'asiri'" [title]="dofTooltip(d)">
          @if(d.durum === 'tam'){ <i class="icon check circle"></i><span>İso-Tanımlı</span> }
          @else if(d.durum === 'asiri'){ <i class="icon exclamation triangle"></i><span>Aşırı ({{d.dof}})</span> }
          @else { <i class="icon unlock"></i><span>{{d.dof ?? d.serbest}} serbest</span> }
        </div>
        <div class="wb-etiket">Durum</div>
      </div>
    }
  }
</div>
}

<!-- NOT: alt Araç Çubuğu -->
@if (gosterAltAracCubugu){
<div class="altAracCubugu">
    <button class="circular ui icon green tiny button"
            title="Seçililer">
        {{ fikoThreejs.secililer?.liste.length }}
    </button>

    <button class="circular ui icon green tiny button"
            [class.fiko-kilit]="!lisans('GORUNTULEME')"
            title="Dosya Aç"
            (click)="tiklandiImportFikoOpGL()">
        <i class="folder open icon"
           style="color: white;font-size: 8pt;"></i>
    </button>

    <button class="circular ui icon blue tiny button"
            title="Komple Kaydet (Sahne + Operasyonlar) - Sıkıştırmalı"
            (click)="kompleKaydet()">
        <i class="save icon"
           style="color: white;font-size: 8pt;"></i>
    </button>

    <button class="circular ui icon teal tiny button"
            title="Aktif Operasyonu Kaydet (.FikoOp) - Sıkıştırmalı"
            (click)="operasyonKaydet()">
        <i class="file export icon"
           style="color: white;font-size: 8pt;"></i>
    </button>


    <button class="circular ui icon green tiny button"
            title="Dikine Bak"
            (click)="dikineBak()">
        <i class="crosshairs icon"
           style="color: black;"></i>
    </button>

    <button class="circular ui icon yellow tiny button"
            title="Ekrana Sığdır"
            (click)="ekranaSigdir()">
        <i class="arrows alternate icon"
           style="color: black;"></i>
    </button>


    <button class="circular ui icon yellow tiny button"
            (click)="toggleSecimModu()"
            title="Seçim Modu">
        <i class="mouse icon"
           [class.pointer]="fikoThreejs?.sahneler?.[0]?.secimler?.aktif"
           style="color: white;font-size: 8pt;"></i>
    </button>

    <!-- 🔗 Topolojik Seçim Modu -->
    <button class="circular ui icon tiny button"
            [class.green]="topolojikSecimModu === 'face_loop'"
            [class.orange]="topolojikSecimModu === 'edge_chain'"
            [class.purple]="topolojikSecimModu === 'radius_group'"
            [class.grey]="topolojikSecimModu === 'tek_kenar'"
            (click)="toggleTopolojikSecimModu()"
            [title]="'Topolojik Seçim: ' + topolojikSecimModuEtiket">
        <i class="linkify icon"
           style="color: white;font-size: 8pt;"></i>
    </button>

    <button class="circular ui icon blue tiny button"
            title="Kameralar"
            (click)="fikoThreejs.sahneler?.[0]?.kaynakca.konumlar.ciftTiklandi()">
        <!-- <i class="video icon"></i> -->
        <img src="/simgeler/kamera.webp">
    </button>

    <button class="circular ui icon teal tiny button"
            title="Ekran Yakalama (Ctrl+Shift+S)"
            (click)="acScreenshotDialog()">
        <i class="camera icon"
           style="color: white;font-size: 8pt;"></i>
    </button>

    <button class="circular ui icon purple tiny button"
            title="Video Kayıt"
            (click)="acVideoKayitDialog()">
        <i class="video icon"
           style="color: white;font-size: 8pt;"></i>
    </button>

    <button class="circular ui icon orange tiny button"
            title="Kütle Bilgisi (Hacim, Ağırlık, Kütle Merkezi)"
            (click)="acMassInfoDialog()">
        <i class="balance scale icon"
           style="color: white;font-size: 8pt;"></i>
    </button>

    <button class="circular ui icon red tiny button"
            title="PDF Rapor Editörü"
            (click)="acPdfEditorDialog()">
        <i class="file pdf icon"
           style="color: white;font-size: 8pt;"></i>
    </button>

    <button class="circular ui icon blue tiny button"
            [class.fiko-kilit]="!lisans('CIZIM','teknik_resim')"
            title="Teknik Resim Editörü (CATDrawing)"
            (click)="acTeknikResimDialog()">
        <i class="drafting compass icon"
           style="color: white;font-size: 8pt;"></i>
    </button>

    <button class="circular ui icon tiny button"
            title="İşbirliği (Collaboration)"
            (click)="fikoThreejs.acCollabDialogu()"
            style="background: linear-gradient(135deg, #00FFFF 0%, #0088FF 100%);">
        <i class="users icon"
           style="color: white;font-size: 8pt;"></i>
    </button>
    <!--  -->
    @for (item of fikoThreejs.sahneler?.[0]?.altAracCubugu ?? []; track $index) {

    <span style="display: flex; align-items: center;">
        @switch (item.tipi) {

        @case ('Ayraç') {
        <span>
            <span style="border-left: 1px solid white;"></span>
        </span>
        }
        @default {
        <button class="circular ui icon {{ item.renkSinif ?? 'green' }} tiny button"
                style="padding: 0 !important;"
                [title]="item.baslik"
                (click)="item.tiklandi ? item.tiklandi():null;">
            @if (item.simge) {
            <i class="icon {{ item.simge }}"
               style="height: 22px;width: 22px;line-height: 20px;"></i>
            }
            @if (item.simgeYazi) {
            <i class="icon"
               style="height: 28px;width: 28px;line-height: 28px;font-size:16px">{{item.simgeYazi}}</i>
            }
            @if (item.resim) {
            <img [src]="item.resim"
                 style="width: 22px !important; height: 22px; object-fit: contain;">
            }
        </button>
        }
        }

    </span>
    }
    <!--  -->
    <span>
        @if ((fikoThreejs.aktifItem?.altAracCubugu ?? []).length>0) {
        <span style="border-left: 1px solid white;"></span>
        }
    </span>

    <!--  -->
    @for (item of fikoThreejs.aktifItem?.altAracCubugu ?? []; track $index) {

    <span style="display: flex; align-items: center;">
        @switch (item.tipi) {

        @case ('Ayraç') {
        <span>
            <span style="border-left: 1px solid white;"></span>
        </span>
        }
        @default {
        <button class="circular ui icon {{ item.renkSinif ?? 'green' }} tiny button"
                style="padding: 0 !important;"
                [title]="item.baslik"
                (click)="item.tiklandi ? item.tiklandi():null;">
            @if (item.simge) {
            <i class="icon {{ item.simge }}"
               style="height: 22px;width: 22px;line-height: 20px;"></i>
            }
            @if (item.simgeYazi) {
            <i class="icon"
               style="height: 22px;width: 22px;line-height: 22px;">{{item.simgeYazi}}</i>
            }
            @if (item.resim) {
            <img [src]="item.resim"
                 style="width: 22px !important; height: 22px; object-fit: contain;">
            }
        </button>
        }
        }

    </span>
    }
</div>


<!-- Fiko Ters Açı Analizi Dialog - Dinamik olarak DialogFiko.ac() ile açılıyor -->

<!-- Fiko-Kesit Dialog -->
<!-- <fikoyt-fiko-kesit #fikoKesitDialog></fikoyt-fiko-kesit> -->

<!-- 📝 Annotation Toolbar - Service-based management, always rendered -->
<fikoyt-annotation-toolbar
  #annotationToolbarRef
  [toolbarId]="'annotationTools'"
  [anaGosterim]="fikoThreejs"></fikoyt-annotation-toolbar>

<!-- 📐 Teknik Resim Toolbar - Three.js tabanlı 2D teknik resim modu -->
<fikoyt-teknik-resim-toolbar
  #teknikResimToolbarRef
  [toolbarId]="'teknikResimTools'"
  [anaGosterim]="fikoThreejs"></fikoyt-teknik-resim-toolbar>

@if (arModuAktif) {
<div class="ar-toolbar"
     style="position:absolute;bottom:60px;left:50%;transform:translateX(-50%);
            display:flex;gap:8px;padding:8px 16px;border-radius:24px;
            background:rgba(0,0,0,0.75);backdrop-filter:blur(12px);z-index:100;
            align-items:center;">

    <button class="ui mini icon button"
            [class.orange]="arModu.anchor.kilitli"
            [class.blue]="!arModu.anchor.kilitli"
            (click)="arAnchorToggle()"
            [title]="arModu.anchor.kilitli ? 'Serbest Bırak' : 'Sabitle'">
        <i class="icon" [class.lock]="arModu.anchor.kilitli" [class.unlock]="!arModu.anchor.kilitli"></i>
    </button>

    <button class="ui mini icon blue button"
            (click)="arModu.sifirla();CD.detectChanges();"
            title="Sıfırla">
        <i class="icon undo"></i>
    </button>

    <button class="ui mini icon teal button"
            (click)="arModu.kameraDegistir()"
            title="Kamera Değiştir (Ön/Arka)">
        <i class="icon sync"></i>
    </button>

    <button class="ui mini icon button"
            [class.green]="arGyroAktif"
            [class.grey]="!arGyroAktif"
            (click)="arGyroToggle()"
            title="Pusula / Gyroscope">
        <i class="icon compass"></i>
    </button>

    <input type="range" min="10" max="100" step="5"
           [value]="arModu.modelOpakligi * 100"
           (input)="arModu.modelOpakligi = $any($event.target).value / 100; CD.detectChanges();"
           title="Model Opaklığı"
           style="width:80px;accent-color:#7C4DFF;">

    <button class="ui mini icon red button"
            (click)="arModuToggle()"
            title="AR'dan Çık">
        <i class="icon close"></i>
    </button>
</div>
}

}

<!-- PDF Editör Seçim Modu Göstergesi -->
@if (pdfSelectionModeActive) {
  <div class="pdf-selection-overlay" (click)="onPdfSelectionOverlayClick($event)">
    <div class="pdf-selection-banner">
      <span class="pulse-dot"></span>
      <span>PDF için nesne seçin - Bir FikoCizimYalin nesnesine tıklayın</span>
      <button class="cancel-btn" (click)="cancelPdfSelection($event)">İptal</button>
    </div>
  </div>
}

<!-- Döküm Kontrol — dialog yok, 3D sahneye gömülü tam overlay -->
@if (dokumKontrolAcik) {
  <fiko-dokum-kontrol [anaGosterim]="fikoThreejs" (kapat)="dokumKontrolKapat()"></fiko-dokum-kontrol>
}

<!-- CATIA Prismatic Machining (yeni CAM) — G-code/APT/Doküman çıktı overlay -->
@if (camCikti) {
  <div style="position:absolute;top:80px;right:14px;width:340px;max-height:74vh;display:flex;flex-direction:column;background:rgba(8,18,30,.96);border:1px solid rgba(0,200,255,.35);border-radius:10px;box-shadow:0 8px 30px rgba(0,0,0,.55);z-index:60;color:#dbe4f0;font:500 12px system-ui;">
    <div style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-bottom:1px solid rgba(0,200,255,.2);font-weight:800;color:#7db0ff;">
      <span style="flex:1;">{{ camCikti.baslik }}</span>
      <button (click)="camCiktiIndir()" title="Dosya olarak indir (.aptsource / .nc)" style="background:none;border:none;color:#7be8a0;cursor:pointer;font-size:14px;">⬇</button>
      <button (click)="camCiktiKopyala()" title="Kopyala" style="background:none;border:none;color:#9cf;cursor:pointer;font-size:14px;">⧉</button>
      <button (click)="camCikti=null" title="Kapat" style="background:none;border:none;color:#f88;cursor:pointer;font-size:14px;">✕</button>
    </div>
    <pre style="margin:0;overflow:auto;padding:8px 10px;font:600 10px/1.35 monospace;color:#9be8b0;white-space:pre;">{{ camCikti.metin }}</pre>
  </div>
}
@if (camCopy) {
  <div style="position:absolute;top:80px;right:14px;width:280px;display:flex;flex-direction:column;gap:6px;background:rgba(8,18,30,.97);border:1px solid rgba(0,200,255,.35);border-radius:10px;box-shadow:0 8px 30px rgba(0,0,0,.55);z-index:61;color:#dbe4f0;font:500 12px system-ui;padding:10px;">
    <div style="display:flex;align-items:center;gap:8px;font-weight:800;color:#7db0ff;">
      <span style="flex:1;">📋 Kopyala / Dönüştür</span>
      <button (click)="camCopyKapat()" style="background:none;border:none;color:#f88;cursor:pointer;font-size:14px;">✕</button>
    </div>
    <div style="font-size:10.5px;color:#9be8b0;">{{ camCopy.op.ad }}</div>
    <div style="display:flex;align-items:center;justify-content:space-between;"><label>Dönüşüm</label>
      <select [(ngModel)]="camCopy.tip" style="background:rgba(10,20,35,.85);color:#fff;border:1px solid rgba(0,200,255,.35);border-radius:5px;padding:3px 5px;">
        <option value="translate">Öteleme</option><option value="rotate">Dönme</option><option value="symmetry">Simetri</option>
      </select>
    </div>
    @if (camCopy.tip !== 'symmetry') {
      <div style="display:flex;align-items:center;justify-content:space-between;"><label>Adet</label><input type="number" [(ngModel)]="camCopy.adet" style="width:80px;background:rgba(0,0,0,.4);color:#fff;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 5px;text-align:right;"/></div>
    }
    @if (camCopy.tip === 'translate') {
      <div style="display:flex;align-items:center;justify-content:space-between;"><label>ΔX</label><input type="number" [(ngModel)]="camCopy.dx" style="width:80px;background:rgba(0,0,0,.4);color:#fff;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 5px;text-align:right;"/></div>
      <div style="display:flex;align-items:center;justify-content:space-between;"><label>ΔY</label><input type="number" [(ngModel)]="camCopy.dy" style="width:80px;background:rgba(0,0,0,.4);color:#fff;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 5px;text-align:right;"/></div>
    }
    @if (camCopy.tip === 'rotate') {
      <div style="display:flex;align-items:center;justify-content:space-between;"><label>Açı (°)</label><input type="number" [(ngModel)]="camCopy.aci" style="width:80px;background:rgba(0,0,0,.4);color:#fff;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 5px;text-align:right;"/></div>
      <div style="display:flex;align-items:center;justify-content:space-between;"><label>Merkez X / Y</label><span><input type="number" [(ngModel)]="camCopy.mx" style="width:42px;background:rgba(0,0,0,.4);color:#fff;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 4px;text-align:right;"/> <input type="number" [(ngModel)]="camCopy.my" style="width:42px;background:rgba(0,0,0,.4);color:#fff;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 4px;text-align:right;"/></span></div>
    }
    @if (camCopy.tip === 'symmetry') {
      <div style="display:flex;align-items:center;justify-content:space-between;"><label>Ayna Ekseni</label>
        <select [(ngModel)]="camCopy.aynaEksen" style="background:rgba(10,20,35,.85);color:#fff;border:1px solid rgba(0,200,255,.35);border-radius:5px;padding:3px 5px;"><option value="x">X (yatay)</option><option value="y">Y (dikey)</option></select>
      </div>
      <div style="display:flex;align-items:center;justify-content:space-between;"><label>Eksen X / Y</label><span><input type="number" [(ngModel)]="camCopy.mx" style="width:42px;background:rgba(0,0,0,.4);color:#fff;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 4px;text-align:right;"/> <input type="number" [(ngModel)]="camCopy.my" style="width:42px;background:rgba(0,0,0,.4);color:#fff;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 4px;text-align:right;"/></span></div>
    }
    <button (click)="camCopyUygula()" style="margin-top:4px;background:rgba(20,120,80,.55);border:1px solid rgba(52,211,153,.5);color:#a7f3d0;border-radius:6px;padding:7px;font-weight:700;cursor:pointer;">✔ Uygula</button>
  </div>
}
@if (camSecimHud; as hud) {
  <div class="cam-sec-hud" [style.--hc]="camHudBilgi[hud.mod].renk">
    <div class="cam-sec-hud-ic">
      <span class="cam-sec-ikon">{{ camHudBilgi[hud.mod].ikon }}</span>
      <div class="cam-sec-metin">
        <div class="cam-sec-ad">{{ hud.ek ? (hud.ek + ' SEÇİMİ') : camHudBilgi[hud.mod].ad }}</div>
        <div class="cam-sec-ipucu">{{ camHudBilgi[hud.mod].ipucu }}</div>
      </div>
      <div class="cam-sec-sayac">{{ hud.sayi }}<small>seçili</small></div>
    </div>
    <div class="cam-sec-tarama"></div>
  </div>
}
<!-- CAM Eksenel kategori flyout (overlay seviyesi — ribbon çerçevesinden bağımsız, kırpılmaz) -->
@if (camAcikKat) {
  <div class="wb-fly-menu" [style.left.px]="camFlyKonum.x" [style.bottom.px]="camFlyKonum.y">
    @for (t of camAktifKatOps; track t) {
      <button class="wb-fly-op" (click)="camKatOp(t)"><i class="icon {{camOpIkon(t)}}"></i>{{ camOpAd(t) }}</button>
    }
  </div>
}

} <!-- /@if (!gomulu) -->
